import * as React from 'react';
import { EImageSizeType } from '../../types/index';
import { ImagesEmpty40, ImagesEmpty16 } from '../../../icons/index';
export var Error = function Error(_ref) {
  var className = _ref.className,
      size = _ref.size;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, size === EImageSizeType.L ? /*#__PURE__*/React.createElement(ImagesEmpty40, null) : /*#__PURE__*/React.createElement(ImagesEmpty16, null));
};